<template>
  <div id="contenedor-listado-solicitudes-obras-desktop">
    <v-data-table :headers="headers" :items="listadoSolicitudesObras" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :solicitudObra="item" :firma="firma"></opciones>
      </template>
      <template v-slot:[`item.fechaMemorandum`]="{ item }">
        {{ new Date(item.fechaMemorandum).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
      <template v-slot:[`item.meta`]="{ item }">
        <cortar-texto
        :texto="item.meta"></cortar-texto>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ListadoSolicitudesObrasDesktop',
  props: {
    listadoSolicitudesObras: {
      type: Array,
      required: true,
    },
    firma: {
      type: Object,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
    CortarTexto,
  },
  data() {
    return {
      headers: [
        {
          text: 'Número de Memorándum',
          align: 'start',
          value: 'numeroMemorandum',
          width: '150',
          sortable: false,
        },
        { text: 'Fecha', value: 'fechaMemorandum', sortable: false },

        { text: 'Objeto', value: 'meta', sortable: false },
        { text: 'Número de Oficio de Solicitud', value: 'numeroOficioSolicitud', sortable: false },
        { text: 'Fecha de Of. Sol.', value: 'fechaOficioSolicitud', sortable: false },
        { text: 'F. Registro', value: 'createdAt', width: '120' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
